import { ViewModel, View, ObservableArray, ViewModelMessage } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { AccessManagementView } from "./accessManagement-view"

export class AccessManagementViewModel extends WindowViewModel {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filteredUsers = ObservableArray.create<UserViewModel>();
        this.users = ObservableArray.create<UserViewModel>();
        this.allForms = ObservableArray.create<IForm>();
        this.leafNodes = ObservableArray.create<SingleForm>();
        this.refresh();
    }

    GetDefaultView(): View<ViewModel> {
        return new AccessManagementView();
    }
    public getTypeId(): string {
        return "VM-623AEFD3-3B4E-412C-879B-1A2F8CED08B1"
    }

    public getTitle(): string {
        return translate("accessManagement-viewModel.accessControl", {});
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    public set users(v: ObservableArray<UserViewModel>) { this._users = v; } public get users(): ObservableArray<UserViewModel> { return this._users; } private _users: ObservableArray<UserViewModel>;
    public set filteredUsers(v: ObservableArray<UserViewModel>) { this._filteredUsers = v; } public get filteredUsers(): ObservableArray<UserViewModel> { return this._filteredUsers; } private _filteredUsers: ObservableArray<UserViewModel>;
    public set selectedUser(v: UserViewModel) { this._selectedUser = v; } public get selectedUser(): UserViewModel { return this._selectedUser; } private _selectedUser: UserViewModel;
    public set searchedUserNameText(v: string) {
        this._searchedUserNameText = v;
        this.startFilterUsers();
    } public get searchedUserNameText(): string { return this._searchedUserNameText; } private _searchedUserNameText: string;
    private searchUserTimer;

    public set allForms(v: ObservableArray<IForm>) { this._allForms = v; } public get allForms(): ObservableArray<IForm> { return this._allForms;} private _allForms: ObservableArray<IForm>;
    public set leafNodes(v: ObservableArray<SingleForm>) { this._leafNodes = v; } public get leafNodes(): ObservableArray<SingleForm> { return this._leafNodes;} private _leafNodes: ObservableArray<SingleForm>;
      
    

    async refresh() {
        try {
            this.isLoading = true;
            await Promise.all([this.getAllUsers(), this.getAllForms()]);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }

        this.isLoading = true;
        await this.getAllUsers();
        await this.getAllForms();
        await this.filteredUsers.update(...this.users);
        this.isLoading = false;
    }

    async getAllUsers() {
        try {
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/GetAllUsers', {});
            this.users.update(...result.Users.map(x => {
                let r = new UserViewModel(this);
                r.userId = x.Id;
                r.username = x.Username;
                r.setPersonnelFullName(x.PersonnelName, x.PersonnelLastName);
                return r;
            }));
        }
        catch (ex) {
            console.log(ex);
        }
    }

    async getAllForms() {
        try {
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/GetAllForms', {});
            
            let allForms : SingleForm[] = result.Forms.map(x=>{
                let r = new SingleForm(this);
                r.id = x.Id;
                r.formFullName = x.Name;
                r.hasAccess = false;
                r.position = x.Position;
                return r;
            });
            let root = new FormFolder(this);
            allForms.forEach(x=>root.addForm(x,x.formFullName.split("/")));
            root.sortChildren();
            this.allForms.update(...root.children);
            this.leafNodes.update(...root.getLeafNodes());
        }
        catch (ex) {
            console.log(ex);
        }
    }

    async getAccessibleForms() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/GetAccessibleForms', { UserId: this.selectedUser.userId });
            let accessibleForms = result.Forms.map(x => x.Id);
            this.leafNodes.forEach(element => {
                if (accessibleForms.includes(element.id)){
                    element.hasAccess = true;
                } else {
                    element.hasAccess = false
                }
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    selectUser(user: UserViewModel) {
        this.users.forEach(x => x.isSelected = false);
        user.isSelected = true;
        this.selectedUser = user;
        this.getAccessibleForms();
    }

    async save() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/SetUserAccesses', {
                UserId: this.selectedUser.userId,
                AllowedForms: this.leafNodes.filter(x => x.hasAccess == true).map(x => x.id)
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess("اطلاعات با موفقیت ذخیره شد.", "تنظیم دسترسی");
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning("مشکلی در ذخیره سازی وجود دارد.", "تنظیم دسترسی");
        } finally {
            this.isLoading = false;
        }
    }

    startFilterUsers() {
        if (this.searchUserTimer) {
            clearTimeout(this.searchUserTimer);
        }
        this.searchUserTimer = setTimeout(() => {
            this.filteredUsers.update(...this.users.filter(user => user.personnelFullName.includes(this.searchedUserNameText) || user.username.includes(this.searchedUserNameText)));
        }, 500);
    }

    
}

export interface IForm{
    name:string;
    position : number;
    sortChildren();
    getLeafNodes() : SingleForm[];
    updateAccessRights(value : boolean);
    recheckAccessRights();
    getAccess():boolean;

}
export class FormFolder extends ViewModel implements IForm{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.children = ObservableArray.create<IForm>();
        this.position = 10000000;
        this.indeterminate = false;
    }
    public set parent(v: FormFolder) { this._parent = v; } public get parent(): FormFolder { return this._parent;} private _parent: FormFolder;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set children(v: ObservableArray<IForm>) { this._children = v; } public get children(): ObservableArray<IForm> { return this._children;} private _children: ObservableArray<IForm>;
    public set hasAccess(v: boolean) { 
        let changed = (this._hasAccess !== v);
        this._hasAccess = v; 
        if(changed){
            this.updateAccessRights(v);
            this.recheckAccessRights();
        }
    } public get hasAccess(): boolean { return this._hasAccess;} private _hasAccess: boolean;
    public set position(v: number) { this._position = v; } public get position(): number { return this._position;} private _position: number;
    public set indeterminate(v: boolean) { this._indeterminate = v; } public get indeterminate(): boolean { return this._indeterminate;} private _indeterminate: boolean;
    
    addForm(form: SingleForm,pathParts : string[]): void {
        if(form.position<this.position)
            this.position = form.position;

        if(pathParts.length==1){
            form.name = pathParts[0];
            form.parent = this;
            this.children.push(form);
        }else{
            let relatedChild : FormFolder = <FormFolder>this.children.filter(x=>x instanceof FormFolder && x.name == pathParts[0] ).at(0);
            if(relatedChild==null){
                relatedChild  = new FormFolder(this);
                relatedChild.parent = this;
                relatedChild.name = pathParts[0];
                relatedChild.hasAccess = false;
                this.children.push(relatedChild);
            }
            relatedChild.addForm(form,pathParts.slice(1));
        }
    }
    sortChildren(){
        this.children.forEach(x=>x.sortChildren());
        this.children.sort((a,b)=>a.position-b.position);
    }

    getLeafNodes() : SingleForm[]{
        let forms = this.children.flatMap(x=>x.getLeafNodes());
        return forms;
    }

    updateAccessRights(value : boolean){
        if(value === true || value === false){
            this.hasAccess = value;
            this.children.forEach(x=>x.updateAccessRights(value))
        }
    }
    recheckAccessRights(){
        if(this.children.length==0){
            this.hasAccess = false;
            this.indeterminate = false;
        }else if(this.children.every(x=>x.getAccess()===true)){
            this.hasAccess = true;
            this.indeterminate = false;

        }else if(this.children.every(x=>x.getAccess()===false)){
            this.hasAccess = false;
            this.indeterminate = false;
        }else{
            this.indeterminate = true;
        }
        this.parent?.recheckAccessRights();
    }

    getAccess():boolean | null{
        if(this.indeterminate){
            return null;
        }
        return this.hasAccess;
    }

}
export class SingleForm extends ViewModel implements IForm{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.indeterminate = false;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set parent(v: FormFolder) { this._parent = v; } public get parent(): FormFolder { return this._parent;} private _parent: FormFolder;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set formFullName(v: string) { this._formFullName = v; } public get formFullName(): string { return this._formFullName;} private _formFullName: string;
    public set hasAccess(v: boolean) { 
        let changed = (this._hasAccess !== v);
        this._hasAccess = v; 
        if(changed){
            this.updateAccessRights(v);
            this.recheckAccessRights();
        }
    } public get hasAccess(): boolean { return this._hasAccess;} private _hasAccess: boolean;
    public set indeterminate(v: boolean) { this._indeterminate = v; } public get indeterminate(): boolean { return this._indeterminate;} private _indeterminate: boolean;
    public set children(v: ObservableArray<SingleForm>) { this._children = v; } public get children(): ObservableArray<SingleForm> { return this._children;} private _children: ObservableArray<SingleForm>;
    public set position(v: number) { this._position = v; } public get position(): number { return this._position;} private _position: number;
    
    sortChildren(){}
    getLeafNodes() : SingleForm[]{
        return [this];
    }

    updateAccessRights(value: boolean) {
        this.hasAccess = value;
    }
    recheckAccessRights() {
        this.parent?.recheckAccessRights();
    }
    getAccess(): boolean {
        return this.hasAccess;
    }

}

export class UserViewModel extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: AccessManagementViewModel) {
        super(parent);
        this.typedParent = parent;
    }

    private typedParent: AccessManagementViewModel;
    public set userId(v: string) { this._userId = v; } public get userId(): string { return this._userId; } private _userId: string;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username; } private _username: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName; } private _personnelName: string;
    public set personnelLastName(v: string) { this._personnelLastName = v; } public get personnelLastName(): string { return this._personnelLastName; } private _personnelLastName: string;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName; } private _personnelFullName: string;

    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected; } private _isSelected: boolean;

    select() {
        this.typedParent.selectUser(this);
    }
    setPersonnelFullName(name: string, lastName: string) {
        this.personnelName = name;
        this.personnelLastName = lastName;
        this.personnelFullName = [name, lastName].filter(x => stringIsNullOrEmpty(x) == false).map(x => x.trim()).join(' ');
    }
    clone(parent: AccessManagementViewModel) {
        let userViewModel = new UserViewModel(parent);
        userViewModel.userId = this.userId;
        userViewModel.username = this.username;
        userViewModel.personnelName = this.personnelName;
        userViewModel.personnelLastName = this.personnelLastName;
        userViewModel.personnelFullName = [userViewModel.personnelName, userViewModel.personnelLastName].filter(x => stringIsNullOrEmpty(x) == false).map(x => x.trim()).join(' ');
        return userViewModel;
    }
}